import axios from "axios";
export default function GetDeplacement(){
    const urlShownotification= `${process.env.REACT_APP_PHP_APP_URL}/delplacement`;
    const GetAllDeplacement=()=>{
        return (axios.get(urlShownotification));
    }
    return {
        GetAllDeplacement
    }
}